/**
 * Derivação da categoria de uma sugestão de IA do consolidador.
 *
 * A categoria sai de `tabela_referencia` + `operacao`, e não de um campo `categoria` que o backend
 * não tem: assim qualquer payload — o de hoje e o de quando o produtor existir — passa pela mesma
 * regra de exibição.
 *
 * Vocabulário e registry moram em `constants/suggestions.js`.
 */
import {
  CATEGORIAS,
  CATEGORIA_ATIVO_AJUSTE,
  CATEGORIA_ATIVO_INCLUSAO,
  CATEGORIA_DESCONHECIDA,
  CATEGORIA_FALLBACK,
  CATEGORIA_MOVIMENTACAO,
  OPERACAO_EDIT,
  TABELA_ATIVO_CLIENTE,
  TABELA_MOVIMENTACAO,
} from '@modules/consolidator/constants/suggestions'

export const derivarCategoria = (suggestion) => {
  const sugestao = suggestion || {}
  if (sugestao.tabela_referencia === TABELA_MOVIMENTACAO) return CATEGORIA_MOVIMENTACAO
  if (sugestao.tabela_referencia === TABELA_ATIVO_CLIENTE) {
    return sugestao.operacao === OPERACAO_EDIT
      ? CATEGORIA_ATIVO_AJUSTE
      : CATEGORIA_ATIVO_INCLUSAO
  }
  return CATEGORIA_DESCONHECIDA
}

export const metaDaCategoria = (categoria) => CATEGORIAS[categoria] || CATEGORIA_FALLBACK

export const ehDeMovimentacao = (suggestion) =>
  derivarCategoria(suggestion) === CATEGORIA_MOVIMENTACAO

export const categoriaAncoraNoAtivo = (suggestion) =>
  metaDaCategoria(derivarCategoria(suggestion)).ancoraNoAtivo

